import { render, staticRenderFns } from "./Protocol.vue?vue&type=template&id=273995d5&scoped=true"
import script from "./Protocol.vue?vue&type=script&lang=ts"
export * from "./Protocol.vue?vue&type=script&lang=ts"
import style0 from "./Protocol.vue?vue&type=style&index=0&id=273995d5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273995d5",
  null
  
)

export default component.exports